import { v4 as uuidv4 } from 'uuid';
import { ajaxSuccess } from './helpers';
import { deleteQuestion } from './questions';

let tokenSource;
const formsSearch = (href, searchValue) => {
    if (typeof tokenSource !== typeof undefined) {
        tokenSource.cancel('Forms speration canceled due to new request.');
    }
    tokenSource = axios.CancelToken.source();

    return new Promise((resolve, reject) => {
        axios({
            url: href,
            method: 'GET',
            cancelToken: tokenSource.token,
            params: { search: searchValue }
        })
        .then((res) => {
            ajaxSuccess(res);
            console.log(res)
            resolve(res);
        }, (err) => {
            console.log(err)
            reject(err);
        })
    })
}
const formUpdateLock = (el) => axios({
    method: 'POST',
    url: el.dataset.href,
    data: {
        lock: el.dataset.lock
    }
})
.then((res) => {
    ajaxSuccess(res);
    const { data: { locked } } = res.data;
    el.dataset.lock = locked ? 0 : 1
    const _tpl = el.querySelector(`template[data-${locked ? 'unlock' : 'lock'}]`).content.cloneNode(true)
    el.querySelector('.inner-content').innerHTML = _tpl.children[0].innerHTML
    return locked
})
const deleteForm = (href, formId, el) => {
    el && el.setAttribute('disabled', true)
    return new Promise((resolve, reject) => {
        axios({
            method: 'DELETE',
            url: href,
            errorHandler: true
        })
        .then((res) => {
            ajaxSuccess(res);
            resolve(res);
        }, (err) => {
            el && el.removeAttribute('disabled', true)
            reject(err);
        })
    })
}

const _createEmptyFormEl = (trans) => `
<div class="col-12">
    <div class="forms-empty-container">
        <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="130.121" height="123.864" viewBox="0 0 30.121 23.864" class="fill-primary">
                <use href="${window.location.origin}/img/icons/empty-box.svg#empty-box" />
            </svg>
        </div>
        <h3 class="container-message font-weight-normal">${trans.noRecordsFound}</h3>
    </div>
</div>
`
const _createFormEl = (form, trans) => `
<div class="col-md-6 col-12 d-flex">
    <div class="box form-box mb-3 ${form.currentUserOwner ? 'my-form' : 'bg-secondary'} data-form-id="${form.id}">
        <div class="box-header mb-2">
            <h3 class="form-title text-primary mb-0">
                <a class="text-primary" href="${form.links.show}">${form.subject}</a>
            </h3>
            <div class="dropdown more-options dropleft">
                <a class="btn form-options-dropdown p-0" href="#" role="button" id="form-options-${form.id}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="6" viewBox="0 0 28 6" class="">
                        <use href="${window.location.origin}/img/icons/menu.svg#menu" />
                    </svg>
                </a>
                
                <div class="dropdown-menu primary mt-3" aria-labelledby="form-options-${form.id}">
                    <a class="dropdown-item text-dark" href="javascript:void(0);" data-clipboard-text="${form.link}">
                        <div class="icon-container icon-prepend">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.613" height="16.166" viewBox="0 0 13.613 16.166" class="fill-primary">
                                <use href="${window.location.origin}/img/icons/copy-link.svg#copy-link" />
                            </svg>
                        </div>
                        <span>${trans.copyLink}</span>
                    </a>
                    ${form.permissions.update ? `
                        <a class="dropdown-item text-dark" href="${form.links.edit}">
                            <div class="icon-container icon-prepend">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.613" height="13.613" viewBox="0 0 13.613 13.613" class="fill-primary">
                                    <use href="${window.location.origin}/img/icons/edit.svg#edit" />
                                </svg>
                            </div>
                            <span>${trans.edit}</span>
                        </a>
                    ` : ''}
                    ${form.isOnNotificationList ? `
                        <a 
                            class="dropdown-item text-dark"
                            href="${form.links.notifications}"
                        >
                            <div class="icon-container icon-prepend">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.613" height="14.748" viewBox="0 0 13.613 14.748" class="fill-primary">
                                    <use href="${window.location.origin}/img/icons/unmuted.svg#unmuted" />
                                </svg>
                            </div>
                            <span>${trans.mute}</span>
                        </a>
                    ` : `
                        <a 
                            class="dropdown-item text-dark" 
                            href="${form.links.notifications}"
                        >
                            <div class="icon-container icon-prepend">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.712" height="16.458" viewBox="0 0 15.712 16.458" class="fill-primary">
                                    <use href="${window.location.origin}/img/icons/muted.svg#muted" />
                                </svg>
                            </div>
                            <span>${trans.unmute}</span>
                        </a>
                    `}
                    ${form.permissions.update ? `
                        <a class="dropdown-item text-dark forms-update-lock" href="javascript:void(0);" data-href="${form.links.updateLock}" data-lock="${Number.parseInt(form.locked)}">
                            <div class="inner-content d-flex align-items-center justify-content-center">
                                ${form.locked ? `
                                    <div class="icon-container icon-prepend">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12.513" height="16.391" viewBox="0 0 12.513 16.391" class="fill-pink stroke-pink">
                                            <use href="${window.location.origin}/img/icons/locked.svg#locked" />
                                        </svg>
                                    </div>
                                    <span>${trans.unlock}</span>
                                ` : `
                                    <div class="icon-container icon-prepend">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12.513" height="16.391" viewBox="0 0 12.513 16.391" class="fill-primary stroke-primary">
                                            <use href="${window.location.origin}/img/icons/unlocked.svg#unlocked" />
                                        </svg>
                                    </div>
                                    <span>${trans.lock}</span>
                                `}
                            </div>
                            <template id="form-unlock-template" data-unlock>
                                <div class="inner-content d-flex align-items-center justify-content-center">
                                    <div class="icon-container icon-prepend">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12.513" height="16.391" viewBox="0 0 12.513 16.391" class="fill-pink stroke-pink">
                                            <use href="${window.location.origin}/img/icons/locked.svg#locked" />
                                        </svg>
                                    </div>
                                    <span>${trans.unlock}</span>
                                </div>
                            </template>
                            <template id="form-lock-template" data-lock>
                                <div class="inner-content d-flex align-items-center justify-content-center">
                                    <div class="icon-container icon-prepend">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12.513" height="16.391" viewBox="0 0 12.513 16.391" class="fill-primary stroke-primary">
                                            <use href="${window.location.origin}/img/icons/unlocked.svg#unlocked" />
                                        </svg>
                                    </div>
                                    <span>${trans.lock}</span>
                                </div>
                            </template>
                        </a>
                    ` : ''}
                    ${form.permissions.delete ? `
                        <a class="dropdown-item text-pink" href="javascript:void(0);" data-toggle="modal" data-target="#deleteForm-${form.id}">
                            <div class="icon-container icon-prepend">
                                <svg id="delete" xmlns="http://www.w3.org/2000/svg" width="12.413" height="15.517" viewBox="0 0 12.413 15.517" class="fill-pink">
                                    <use href="${window.location.origin}/img/icons/delete.svg#delete" />
                                </svg>
                            </div>
                            <span>${trans.delete}</span>
                        </a>
                    ` : ''}
                </div>
            </div>
        </div>
        <div class="box-body">
            ${form.description ? `
                <div class="form-description text-dark mb-3">
                    <div class="half-opacity text-ellipsis">${form.description}</div>
                </div>
            ` : ''}
        </div>
        <div class="box-footer">
            ${form.joinedUsers.length ? `
                <div class="form-users text-dark text-ellipsis mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.596" height="19" viewBox="0 0 20.596 19" class="fill-primary">
                        <use href="${window.location.origin}/img/icons/members.svg#members" />
                    </svg>
                    <div class="user-paticipants-container text-ellipsis">
                    ${form.joinedUsers.map((user, i) => `
                        <div class="user-participant text-ellipsis" data-toggle="tooltip" data-placement="bottom" title="${user.name}">
                            ${(form.joinedUsers.length - 1) != i ? `${user.firstName},` : user.firstName}
                        </div>
                    `)}
                    </div>
                </div>
            ` : ''}
            <div class="form-details">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row">
                        <div class="form-details-questions d-flex align-items-center justify-content-center pr-3" data-form-id="${form.id}" data-toggle="tooltip" data-placement="bottom" title="${trans.questions}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.596 20.596" class="fill-dark">
                                <use href="${window.location.origin}/img/icons/question.svg#question" />
                            </svg>
                            <span class="form-details-count form-question-count pl-1">${form.questionCount}</span>
                        </div>
                        <div class="form-details-replies d-flex align-items-center justify-content-center pr-3" data-form-id="${form.id}" data-toggle="tooltip" data-placement="bottom" title="${trans.replies}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.595 20.595" class="fill-dark">
                                <use href="${window.location.origin}/img/icons/reply.svg#reply" />
                            </svg>
                            <span class="form-details-count form-reply-count pl-1">${form.answerCount}</span>
                        </div>
                        <div class="form-details-attachments d-flex align-items-center justify-content-center" data-form-id="${form.id}" data-toggle="tooltip" data-placement="bottom" title="${trans.attachments}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22.449 22.596" class="fill-dark">
                                <use href="${window.location.origin}/img/icons/attach.svg#attach" />
                            </svg>
                            <span class="form-details-count form-attachnment-count pl-1">${form.attachmentCount}</span>
                        </div>
                    </div>
                    <div class="form-date">
                        <span class="text-dark">${form.createdAt}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal theme-modal form-delete-modal fade" id="deleteForm-${form.id}" role="dialog" aria-labelledby="deleteForm-${form.id}Label" aria-hidden="true">
            <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header pb-2">
                        <h5 class="modal-title text-danger">${trans.deleteForm}</h5>
                    </div>
                    <div class="modal-body text-dark">${trans.deleteFormMessage}</div>
                    <div class="modal-footer p-2 m-auto">
                        <button type="button" class="btn btn-sm btn-danger text-white form-list btn-form-delete" data-form-id="${form.id}" data-href="${form.links.destroy}">${trans.delete}</button>
                        <button type="button" class="btn btn-sm btn-secondary-dark text-white" data-dismiss="modal">${trans.cancel}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;

/* FORM BOX ONCLICK NAVIGATE */
$(document).on('click', '.box.form-box[data-href]', function(e) {
    e.preventDefault()
    const { href = null } = this.dataset
    if(href) window.location = href
})
$(document).on('click', '.box.form-box[data-href] .dropdown-menu a', function(e) {
    e.stopPropagation()
    e.stopImmediatePropagation()
})


/*  FORMS INDEX UPDATE LOCK  */
$(document).on('click', '.forms-update-lock', function(e) {
    formUpdateLock(this)
})
/*  FORM SHOW UPDATE LOCK  */
$(document).on('click', '.form-update-lock', function(e) {
    formUpdateLock(this)
    .then(res => {
        if(res) {
            $('.form-container .form-body .form-questions .form-content .form-create-question-container')
            .fadeOut(250, function() {
                this.remove()
            })
        } else {
            const _tpl = document.querySelector('template#form-create-question-template').content.cloneNode(true)
            $('.form-container .form-body .form-questions .form-content').append(_tpl)
        }
    })
})

/* FORMS INDEX SEARCH */
let searchTimeout;
$(document).on('keyup', '#forms-search-input', function(e) {
    const self = this
    const { value: searchValue, dataset: { href } } = this
    
    if(searchTimeout) clearTimeout(searchTimeout)
    
    searchTimeout = setTimeout(function() {
        formsSearch(href, searchValue)
        .then(res => {
            const { data: { forms, trans } } = res.data
            const $container = $('.forms-list-row')
            $container.fadeOut(125, function() {
                $(this).empty().show()
                if(forms.length) {
                    for(const form of forms) {
                        console.log(form)
                        $container.append(_createFormEl(form, trans))
                    }
                } else {
                    $container.append(_createEmptyFormEl(trans))
                }
            })
        })
    }, 500)
})

/* FORMS INDEX DELETE FORM */
$(document).on('click', '.form-list.btn-form-delete', function(e) {
    const self = this;
    const { href, formId } = self.dataset;
    deleteForm(href, formId, this)
    .then(res => {
        $(`#deleteForm-${formId}`).modal('hide')
        $(`.form-box[data-form-id="${formId}"]`)
        .parent()
        .fadeOut(150, function() {
            this.remove();
        })
    })
})

/* FORMS SHOW DELETE FORM */
$(document).on('click', '.form-profile.btn-form-delete', function(e) {
    const self = this;
    const { href, formId } = self.dataset;
    deleteForm(href, formId, this)
    .then(res => {
        const { data: { formsUrl } } = res.data;
        $(`#deleteForm-${formId}`).modal('hide')
        formsUrl && window.location.replace(formsUrl)
    })
})

/* FORMS SHOW NEW QUESTION */
$(document).on('click', 'button.new-question', function(e) {
    e.preventDefault();
    const _uuid = uuidv4()
    const self = this;
    const _tpl = document.querySelector('#new-form-question-container').content.cloneNode(true)
    _tpl.querySelector('.box.new-question').dataset.tmpQuestion = _uuid
    document.querySelector('.form-questions .form-content .row').prepend(_tpl)
    $(`[data-tmp-question="${_uuid}"]`).parent().collapse('show')
    $(`[data-tmp-question="${_uuid}"]`).parent().on('shown.bs.collapse', function() {
        $(this).find('textarea').trigger('focus')
    })
})

/* FORMS NEW QUESTION MAXLENGTH CHAR COUNT */
$(document).on('keyup', 'form[data-tmp-question] textarea#new-form-question', function(e) {
    const _charCount    = this.getAttribute('maxlength') - this.value.length
    const $charCount    = $('form[data-tmp-question] .char-container .char-count');
    const $charCountMsg = $('form[data-tmp-question] .char-container .char-count-msg');
    
    $charCount.html(_charCount)
    console.log(_charCount)
    console.log($charCountMsg, $charCountMsg.is(':visible'))
    if(_charCount <= 15 && !$charCountMsg.is(':visible')) $charCountMsg.fadeIn();
    else if(_charCount > 15 && $charCountMsg.is(':visible')) $charCountMsg.fadeOut();
})

/* FORMS SHOW NEW QUESION SUBMIT */
$(document).on('click', '.new-question-submit', function(e) {
    e.preventDefault();
    const self = this;
    const $box = $(self).closest('.box.new-question');
    const _question = $box.find('textarea').val().trim()
    console.log(_question)
    console.log(self.closest('form.form-box.new-question').action)
    if(!_question) return;
    $box.append('<div class="new-question-overlay"><i class="fa fa-circle-notch fa-spin m-auto text-pink"></i></div>')
    axios({
        method: 'POST',
        url: self.closest('form.form-box.new-question').action,
        data: {
            question: _question
        },
        errorHandler: true
    })
    .then((res) => {
        ajaxSuccess(res);
        console.log(res)
        if(res?.data?.data?.question) {
            $box.parent().html(res.data.data.question)
        } else {
            // window.location.reload()
        }
    }, (err) => {
        $box.find('.new-question-overlay').fadeOut(150, function() {
            this.remove();
        })
    })
})

/* FORMS SHOW NEW QUESTION DISCARD */
$(document).on('click', '.new-question-discard', function(e) {
    e.preventDefault();
    $(this)
    .closest('.box.new-question')
    .parent()
    .collapse('hide')
})

/* FORMS SHOW DELETE QUESTION */
$(document).on('click', '.form-container .form-body .form-questions .btn-question-delete', function(e) {
    const { href, questionId } = this.dataset;
    deleteQuestion(href, questionId, this)
    .then((res) => {
        console.log(res)
        $(`#deleteQuestion-${questionId}`).modal('hide')
        $(`.form-box[data-question-id="${questionId}"]`)
        .parent()
        .collapse('hide')
    })
})

/* REMOVE HTML ELEMENT ON QUESTION DELETE */
$(document).on('hidden.bs.collapse', '.collapse[data-question-column]', function () {
    this.remove()
})


/* FORMS CREATE */
$(document).on('keyup', '#form-subject-input', function(e) {
    $('#form-subject-char-count').html(this.getAttribute('maxlength') - this.value.length)
})
$(document).on('keyup', '#form-slug-input', function(e) {
    const $this = $(this)
    const regex = RegExp('^[a-z0-9]+(?:-[a-z0-9-_]+)*$')
    const $container = $('.form-slug-container')
    const $inputGroupContainer = $container.find('.input-group')
    const $feedbackContainer = $container.find('.invalid-feedback')

    if((regex.test(this.value) || !this.value.length) && $feedbackContainer.is(':visible')) {
        $feedbackContainer.hide()
        $this.removeClass('is-invalid')
        $inputGroupContainer.removeClass('is-invalid')
    } else if(!regex.test(this.value) && !$feedbackContainer.is(':visible')) {
        $feedbackContainer.show()
        if(!$this.hasClass('is-invalid')) $this.addClass('is-invalid')
        if(!$inputGroupContainer.hasClass('is-invalid')) $inputGroupContainer.addClass('is-invalid')
    }
})

// $(document).on('shown.bs.collapse', '#form-description-container.collapse', function(e) {
//     $('#btn-toggle-form-description').remove()
// })

$(document).on('show.bs.collapse', '#form-description-container.collapse', function(e) {
    const _tpl = document
        .querySelector('template#form-description-btn-content')
        .content
        .cloneNode(true)
        .querySelector('.remove-description')
        .innerHTML

    $('button[href="#form-description-container"] .inner-content').html(_tpl)
})

$(document).on('hide.bs.collapse', '#form-description-container.collapse', function(e) {
    const _tpl = document
        .querySelector('template#form-description-btn-content')
        .content
        .cloneNode(true)
        .querySelector('.add-description')
        .innerHTML

    $('button[href="#form-description-container"] .inner-content').html(_tpl)
})
$(document).on('hidden.bs.collapse', '#form-description-container.collapse', function(e) {
    $(this).find('textarea#form-description-input').val('')
})


$(document).on('change', '#form-private-input', function(e) {
    const { checked } = this
    $('#form-password-container').collapse(checked ? 'hide' : 'show')
})

$(document).on('click', '.btn-obscure-password', function(e) {
    e.preventDefault()

    const $this = $(this)
    const $svg  = $this.find('svg')

    const $input = $this
    .closest('.form-group')
    .find('input[name="password"]')

    if($input.attr('type') == 'text') {
        $input.attr('type', 'password')
        $svg.removeClass('stroke-muted')
    } else {
        $input.attr('type', 'text')
        $svg.addClass('stroke-muted')
    }
})

/* FORM NICKNAME SECTION */
$(document).on('click', '#guest-notification-container #form-guest-notifications', function(e) {
    const _checked = $(this).is(':checked')
    $('.form-nickname-email-container').collapse(_checked ? 'show' : 'hide')
    if(!_checked) $('.form-nickname-email-container').val(null)
}) 